import { useControlledSwr } from '@systemeio/util'
import { toast } from 'shared/components'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { RequestModuleEnum } from '../../../shared/enums/request-module-enum'
import { TEMPLATE_PATH } from '../api'
import { SmsTemplateInterface } from '../types'

export function useSmsTemplate(
  id?: SmsTemplateInterface['id'],
  noRedirectOnNotFoundError: boolean = false,
) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, SmsTemplateInterface>({
    method: RequestMethodsEnum.get,
    onNotFound: noRedirectOnNotFoundError
      ? error => {
          toast.error(error.message)
          throw error
        }
      : undefined,
  })

  const { data: template, mutate } = useControlledSwr(() => {
    if (!user) return null
    if (!id) return null
    return [`${TEMPLATE_PATH}/${id}`, RequestModuleEnum.SmsTemplates]
  }, fetcher)

  return { template, mutate }
}
